import InboxEmptyIcon from '../../../../../../../assets/icons/img-inbox-empty.svg?react'
import css from './InboxDropdownEmpty.module.css'

const InboxDropdownEmpty = () => {
    return (
        <div className={css.container}>
            <InboxEmptyIcon />
        </div>
    )
}

export default InboxDropdownEmpty
